import { useDispatch } from 'react-redux'
import { addToasterMessage } from 'shared/store/toaster'

export const useToaster = () => {
  const appDispatch = useDispatch()

  const toast = (message: string, type: 'success' | 'danger') => {
    appDispatch(addToasterMessage({ text: message, type }))
  }

  return { toast }
}
